import React from "react"
import { RellaxWrapper as Rellax } from "react-rellax-wrapper"
import useInstagramImages from "./useInstagramImages"
import useWindowWidth from "@hooks/window-width"

import Twitter from "@assets/svg/twitter-red.inline.svg"
import Facebook from "@assets/svg/facebook-red.inline.svg"
import Instagram from "@assets/svg/instagram-red.inline.svg"
import pint from "@assets/images/euro-header/pint.png"

import * as s from "./InstagramFeed.module.scss"

const InstagramFeed = ({ data }) => {
  const { heading, blurb, backgroundImage } = data
  const images = useInstagramImages()
  const windowWidth = useWindowWidth()

  const numImages = windowWidth < 1024 ? 4 : 12
  const displayImages = images
    ?.filter(image => image.mediaType === "IMAGE")
    ?.filter((_, index) => index < numImages)

  // If we don't have images to display, get an array of the right length
  // to temporarily map over and create placeholders
  const noDisplayImages =
    !images || displayImages.length === 0 ? [...new Array(numImages)] : null

  const socials = [
    {
      key: "Twitter",
      icon: Twitter,
      link: "https://twitter.com/tennentslager",
      display: "TennentsLager",
    },
    {
      key: "Facebook",
      icon: Facebook,
      link: "https://facebook.com/tennentslager",
      display: "TennentsLager",
    },
    {
      key: "Instagram",
      icon: Instagram,
      link: "https://instagram.com/tennentslager",
      display: "tennentslager",
    },
  ]

  return (
    <div
      className={`${s.instagramFeed}`}
      style={{ backgroundImage: `url(${backgroundImage.sourceUrl})` }}
    >
      <div className={`${s.instagramFeed__header}`}>
        <h2 className={`${s.instagramFeed__header___title}`}>{heading}</h2>
        <div className={`${s.instagramFeed__header___socials}`}>
          {socials.map(social => (
            <a
              key={social.key}
              href={social.link}
              target="_blank"
              rel="noreferrer"
              className={`${s.instagramFeed__header___social}`}
            >
              <social.icon
                className={`${s.instagramFeed__header___social___icon}`}
              />

              <span className={`${s.instagramFeed__header___social___text}`}>
                {social.display}
              </span>
            </a>
          ))}
        </div>
        <h4 className={`${s.instagramFeed__header___blurb}`}>{blurb}</h4>
      </div>
      <div className={`${s.instagramFeed__imageGrid}`}>
        {noDisplayImages
          ? noDisplayImages.map((_, index) => (
              <div
                key={index}
                className={`${s.instagramFeed__imageGrid___placeholder}`}
                style={{ height: `calc(100vw / ${numImages / 2})` }}
              />
            ))
          : displayImages.map(image => (
              <a key={image.id} href={image.permalink}>
                <img src={image.mediaUrl} alt="" />
              </a>
            ))}

        <Rellax
          center={true}
          xs={1}
          mobile={1}
          tablet={1}
          desktop={1.2}
          className={`${s.instagramFeed__imageGrid___pint}`}
        >
          <img src={pint} alt="" />
        </Rellax>
      </div>
    </div>
  )
}

export default InstagramFeed
